import {
  dateStringToDateTime,
  loadFormConfiguration,
  newMapFormValues,
  serverValidationFailed,
  signUp,
  signUpAsGuest,
  toIsoString
} from "@awe-web/shared/lib";
import { getContractTypeForB2cSTR } from "../../../config/store.js";
import { B2C_SignUpSuccess } from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState, context) => {
  const captchaSiteKey = await context.api.user.getCaptchaSiteKey();
  await dispatch({
    type: "USER/CAPTCHA_SITEKEY_LOADED",
    payload: {
      captchaSiteKey: captchaSiteKey
    }
  });
  await dispatch(loadFormConfiguration("register"));
};

export const initializeGuestRegister = () => async (dispatch, getState, context) => {
  const captchaSiteKey = await context.api.user.getCaptchaSiteKey();
  await dispatch({
    type: "USER/CAPTCHA_SITEKEY_LOADED",
    payload: {
      captchaSiteKey: captchaSiteKey
    }
  });
  await dispatch(loadFormConfiguration("guestRegistration"));
};


const normalizeDate = value => toIsoString(dateStringToDateTime(value));



export const submitRegisterAsGuest = (formValues, { setSubmitting, validateForm }, redirectPath) => async (dispatch, getState) => {
  const contractTypeForMail = getContractTypeForB2cSTR(getState());
  const mapFormValues = newMapFormValues("guestRegistration")(getState());
  const normalizedValues = mapFormValues({
    ...formValues,
    "Driver:birthdate": normalizeDate(formValues["Driver:birthdate"]),
    "Driver:identCardIssued": normalizeDate(formValues["Driver:identCardIssued"]),
    "Driver:identcardValidTill": normalizeDate(formValues["Driver:identcardValidTill"]),
    "Driver:licenceDateIssued": normalizeDate(formValues["Driver:licenceDateIssued"]),
    contractTypeForMail
  });

  try {
    setSubmitting(true);
    await dispatch(signUpAsGuest(normalizedValues));
    return redirectPath;
  }
  catch (error) {
    if (error.type === "CAPTCHA_REQUIRED") {
      return;
    }
    if (error.type === "VALIDATION_FAILED") {
      const groupName = "guestRegistration";
      const values = formValues;
      const errors = error.errors;
      dispatch(serverValidationFailed(groupName, values, errors));
      setTimeout(() => {
        validateForm();
      }, 200);

      return;
    }

    throw error;
  }
  finally {
    setSubmitting(false);
  }
};



export const submit = (formValues, { setSubmitting, validateForm }) => async (dispatch, getState) => {
  const contractTypeForMail = getContractTypeForB2cSTR(getState());
  const mapFormValues = newMapFormValues("register")(getState());
  const normalizedValues = mapFormValues({
    ...formValues,
    "Driver:birthdate": normalizeDate(formValues["Driver:birthdate"]),
    contractTypeForMail
  });

  try {
    setSubmitting(true);
    await dispatch(signUp(normalizedValues));
    return B2C_SignUpSuccess.path();
  }
  catch (error) {
    if (error.type === "CAPTCHA_REQUIRED") {
      return;
    }
    if (error.type === "VALIDATION_FAILED") {
      const groupName = "register";
      const values = formValues;
      const errors = error.errors;
      dispatch(serverValidationFailed(groupName, values, errors));
      setTimeout(() => {
        validateForm();
      }, 200);

      return;
    }

    throw error;
  }
  finally {
    setSubmitting(false);
  }
};
